import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TimePickerComponent } from './cron-time-picker.component';
import { CronGenComponent } from './cron-editor.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared-module/shared-module.module';

// NG-Zorro: NzTabs/NzRadio/NzCheckbox/NzSelect/NzInput/NzIcon/NzTooltip
// e o pipe translateTA chegam via SharedModule (exports).

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
    exports: [TimePickerComponent, CronGenComponent],
    declarations: [TimePickerComponent, CronGenComponent]
})
export class CronEditorModule {
}
